import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

const Widget = () => {
  const { i18n } = useTranslation();

  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return { 
      width, 
      height 
    };
  };

  const [height, setHeight] = React.useState(300);

  useEffect(() => {
    const { height } = getWindowDimensions();
    setHeight(height - height * 0.1);
  }, []);

  const widgetLanguage = i18n.language === "en" ? "en" : "ar";

  return (
    <>
      <div
        id="finlogix-container"
        className="finlogix-container"
        style={{
          height,
          zIndex: 3,
          position: "relative",
          fontSize: "4rem",
          direction: widgetLanguage === "ar" ? "rtl" : "ltr", // ضبط اتجاه النص
        }}
      ></div>

      <Helmet>
        <script src="https://widget.finlogix.com/Widget.js"></script>

        <script type="text/javascript">
          {`
            setTimeout(() => {
              Widget.init({
                type: "EconomicCalendar",
                language: "${widgetLanguage}",
                importanceOptions: [
                  "low",
                  "medium",
                  "high"
                ],
                dateRangeOptions: [
                  "recentAndNext",
                  "thisWeek",
                  "today",
                  "tomorrow",
                  "nextWeek",
                  "thisMonth"
                ],
                isAdaptive: true
              });
            }, 1000);
          `}
        </script>
      </Helmet>
    </>
  );
};

export default Widget;
